// Nome padrão dos PDFs em TODAS as superfícies (app, Painel do Gestor, Painel do Consultor):
//   Phoenix_Relatorio_Master_<Empresa>.pdf  |  Phoenix_Dossie_360_<Empresa>.pdf
export function nomeArquivoRelatorio(tipo, empresa) {
  const base = tipo === '360' ? 'Phoenix_Dossie_360' : 'Phoenix_Relatorio_Master';
  const limpo = String(empresa || 'Empresa')
    .replace(/[\\/:*?"<>|]/g, '')
    .trim()
    .replace(/\s+/g, '_');
  return `${base}_${limpo || 'Empresa'}.pdf`;
}
